import * as yup from 'yup';

export const schema = yup.object().shape({
  firstName: yup.string().required('First name is a required field'),
  lastName: yup.string().required('Last name is a required field'),
  email: yup.string().email().required('Email is a required field'),
  clientType: yup.array().of(yup.string()).required('Client type is a required field'),
  phone: yup
    .string()
    .nullable()
    .notRequired()
    .test('is-valid-phone', 'Must be a valid phone number for region US', function (value) {
      if (!value || value.trim() === '') return true; // skip validation
      return yup.string().phone('US').isValidSync(value); // validate if not empty
    }),
});
